import { useCallback } from 'react';
import { useTAApi } from 'modules/codeless-events/providers/TAApiProvider';
import { useTrackingApi } from 'services/api';
import { useConversions } from './useConversions';

export const useSaveBulkRules = ({ onSuccess = () => {}, onFailure = error => {} } = {}) => {
    const { conversionsToSave } = useConversions();
    const { saveBulkRules: saveBulkRulesApi } = useTrackingApi();
    const { accountId } = useTAApi();

    const saveBulkRules = useCallback(async () => {
        try {
            const bulkSaveResult = await saveBulkRulesApi(accountId, conversionsToSave);
            const elements = bulkSaveResult?.elements ?? [];
            const hasValidationErrors = elements.some(element => {
                const status = element?.error?.httpStatus;
                return status && status >= 400;
            });
            if (hasValidationErrors) {
                onFailure();
            } else {
                onSuccess();
            }
        } catch (error) {
            onFailure(error);
        }
    }, [accountId, conversionsToSave, saveBulkRulesApi, onSuccess, onFailure]);

    return saveBulkRules;
};
